import toast from 'cogo-toast'
import copy from 'copy-to-clipboard'
import { string as stringSchema } from 'yup'

import { I18n } from '@lingui/core'
import { t } from '@lingui/macro'

// refine URL if window is provided
// and URL is relative
export function fixUrl(url: string): string {
  const schema = stringSchema().url()

  if (typeof window !== 'undefined' && !schema.isValidSync(url)) {
    return `${window.location.protocol}//${window.location.hostname}${url}`
  }

  return url
}

export const attachTokenInviteToLink = async (shareData) => {
  try {
    if (typeof shareData.callback !== 'undefined') {
      const tokenInviteURL = await shareData.callback()

      return `/invite${tokenInviteURL}`
    }
  } catch (exception) {
    console.error(exception)
  }

  return shareData.url
}

export const copyShareLink =
  (navigatorShare: boolean, shareData, copyUrl: string, i18n: I18n) =>
  async () => {
    if (navigatorShare) {
      try {
        await window.navigator.share({
          text: shareData.text,
          title: shareData.title,
          url: fixUrl(copyUrl),
        })

        toast.success(t(i18n)`Link condiviso`)
      } catch (exception) {
        console.error(exception)
      }
    } else {
      copy(fixUrl(copyUrl))

      toast.success(t(i18n)`Link copiato negli appunti`)
    }
  }

export const shareCallback =
  (navigatorShare: boolean, shareData, i18n: I18n) => async () => {
    const shareUrl = await attachTokenInviteToLink(shareData)

    if (navigatorShare) {
      try {
        await window.navigator.share({
          text: shareData.text,
          title: shareData.title,
          url: fixUrl(shareUrl),
        })

        toast.success(t(i18n)`Link condiviso`)
      } catch (exception) {
        console.error(exception)
      }
    } else {
      copy(fixUrl(shareUrl))

      toast.success(t(i18n)`Link copiato negli appunti`)
    }
  }
